// extracted by mini-css-extract-plugin
export default {"list":"list--MA9NM","link":"link--MA9NM"};